import {FormErrorMessage} from '@chakra-ui/react';

export default function ChakraFormErrorMessage({children, ...rest}) {
    return <FormErrorMessage {...rest}>{children}</FormErrorMessage>;
}
